import { render, staticRenderFns } from "./DescriptionComponent.vue?vue&type=template&id=5dbdc716&scoped=true&"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js&"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionComponent.vue?vue&type=style&index=0&id=5dbdc716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbdc716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbdc716')) {
      api.createRecord('5dbdc716', component.options)
    } else {
      api.reload('5dbdc716', component.options)
    }
    module.hot.accept("./DescriptionComponent.vue?vue&type=template&id=5dbdc716&scoped=true&", function () {
      api.rerender('5dbdc716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referralPage/partials/DescriptionComponent.vue"
export default component.exports